import { render } from "./DashboardDailyBilling.vue?vue&type=template&id=fc70dbe4&scoped=true&ts=true"
import script from "./DashboardDailyBilling.vue?vue&type=script&lang=ts"
export * from "./DashboardDailyBilling.vue?vue&type=script&lang=ts"

import "./DashboardDailyBilling.vue?vue&type=style&index=0&id=fc70dbe4&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc70dbe4"]])

export default __exports__